






















//#region imports
import { Vue, Component, Inject } from "vue-property-decorator";
import { DOCUMENTS, DOCUMENTS_EDIT } from "@/route-names";
import EventBus from "@models/eventBus";
import DocumentResponse from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/DocumentService/DocumentResponse";
import DocumentTranslationResponse from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/DocumentService/DocumentTranslationResponse";
import DocumentUpdateRequest from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/DocumentService/DocumentUpdateRequest";
import DocumentService from "@/api/dataSource/api/Spirit/Admin/Services/DocumentService";
//#endregion

@Component
export default class PageDocumentsComponent extends Vue {
  @Inject("eventBus") eventBus: EventBus;
  columnNames = ["Тип документа", ""];
  createRouteName = DOCUMENTS;
  editRouteName = DOCUMENTS_EDIT;
  getDataFunc = this.$api.DocumentService.getListAsync.bind(
    this.$api.DocumentService
  );
  async created() {
    const items = await this.$api.DocumentService.getDocumentByIdAsync(1);
  }
}
